export function flattenStrings(obj: unknown): string[] {
  const result: string[] = [];

  const flattenValues = (value: unknown): void => {
    if (value == null) return;

    if (typeof value === 'string') {
      result.push(value.toLowerCase());
      return;
    }

    if (typeof value === 'number' || typeof value === 'boolean') {
      result.push(value.toString().toLowerCase());
      return;
    }

    if (Array.isArray(value)) {
      value.forEach(flattenValues);
      return;
    }

    if (typeof value === 'object') {
      Object.values(value).forEach(flattenValues);
    }
  };

  flattenValues(obj);
  return result;
}
